// material-ui

import insertextraactionicon from '../../../assets/images/insert-extra-action.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const InsertExtraActionIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={insertextraactionicon} alt="Insert Extra action" width="22"  />
    );
};

export default InsertExtraActionIcon;
